import styled from 'styled-components';

import { TextLabel } from '../../components/TextLabel';

const StyledContainer = styled.div`
	opacity: 0;
	transition: opacity 0.3s ease;
`;

const StyledInterfaceContainer = styled.div`
	opacity: 1;
	transition: opacity 0.3s ease;

	&.interface-enter {
		opacity: 1;
	}

	&.interface-enter-active,
	&.interface-enter-done,
	&.interface-exit {
		opacity: 0;
	}

	&.interface-exit-active {
		opacity: 1;
	}
`;

const StyledModeTextLabel = styled(TextLabel)`
	position: absolute;
	top: 60px;
	left: 60px;
	font-size: 16px;
	color: #ffffff;
`;

const StyledSpan = styled.span`
	font-weight: 700;
	transition: opacity 0.3s ease;

	&.mode-enter {
		opacity: 0;
	}

	&.mode-enter-active,
	&.mode-enter-done,
	&.mode-exit {
		opacity: 1;
	}

	&.mode-exit-active {
		opacity: 0;
	}
`;

export {
	StyledContainer,
	StyledModeTextLabel,
	StyledInterfaceContainer,
	StyledSpan,
};
